import { Validator } from "breeze-client";

interface ValidationMessageContext {
    name?: string;
    displayName?: string;
    messageTemplate?: string;
    message?: string | ((vc: ValidationMessageContext) => string);
    minimum?: number;
    maximum?: number;
    [key: string]: unknown;
}

interface ValidatorFactory {
    name: string;
    build(this: void, context: ValidationMessageContext): Validator;
}

export const customValidators: Validator[] = [];

export const customValidatorFactories: ValidatorFactory[] = [
    {
        name: "range",
        build(context: ValidationMessageContext) {
            if (typeof context.minimum !== "number" || typeof context.maximum !== "number") {
                throw new Error("Expected a minimum and maximum number");
            }

            const min = context.minimum;
            const max = context.maximum;

            const validatorOptions: Record<string, unknown> = {
                ...context,
                messageTemplate: "%displayName% must be between %minimum% and %maximum%",
            };

            return new Validator(
                "range",
                ((v: number) => min <= v && v <= max) as (
                    value: unknown,
                    context?: unknown,
                ) => boolean,
                validatorOptions,
            );
        },
    },
];
